import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'components/core/Image';

import storage25Image from 'assets/images/facility/facility-page/unit--25sqft.svg';
import storage50Image from 'assets/images/facility/facility-page/unit--50sqft.svg';
import storage75Image from 'assets/images/facility/facility-page/unit--75sqft.svg';
import storage100Image from 'assets/images/facility/facility-page/unit--100sqft.svg';
import storage150Image from 'assets/images/facility/facility-page/unit--150sqft.svg';
import storage200Image from 'assets/images/facility/facility-page/unit--200sqft.svg';
import storage300Image from 'assets/images/facility/facility-page/unit--300sqft.svg';
import outdoorImage from 'assets/images/size-guide/unit--parking-outdoor.png';
import parkingImage from 'assets/images/size-guide/unit--parking.png';
import lockerImage from 'assets/images/facility/facility-page/unit--locker.svg';
import workspaceImage from 'assets/images/facility/facility-page/unit--workspace.svg';
import wineImage from 'assets/images/facility/facility-page/unit--wine.svg';
import parking150Image from 'assets/images/facility/facility-page/unit--parking-150sqft.svg';
import parking200Image from 'assets/images/facility/facility-page/unit--parking-200sqft.svg';
import parking250Image from 'assets/images/facility/facility-page/unit--parking-250sqft.svg';
import parking300Image from 'assets/images/facility/facility-page/unit--parking-300sqft.svg';
import parking350Image from 'assets/images/facility/facility-page/unit--parking-350sqft.svg';
import parking400Image from 'assets/images/facility/facility-page/unit--parking-400sqft.svg';
import parking500Image from 'assets/images/facility/facility-page/unit--parking-500sqft.svg';

const icons = {
	25: storage25Image,
	50: storage50Image,
	75: storage75Image,
	100: storage100Image,
	150: storage150Image,
	200: storage200Image,
	300: storage300Image,
};

const parkingIcons = {
	150: parking150Image,
	200: parking200Image,
	250: parking250Image,
	300: parking300Image,
	350: parking350Image,
	400: parking400Image,
	500: parking500Image,
};

function getStorageClass(squareFootage, iconMap) {
	const storageClasses = Object.keys(iconMap);

	for (const storageClass of storageClasses) {
		if (squareFootage <= storageClass) {
			return storageClass;
		}
	}
	return storageClasses.at(-1);
}

export function UnitIconV2({ amenities, squareFootage, type, className }) {
	let src;

	switch (type) {
		case 'locker':
			src = lockerImage;
			break;
		case 'parking_space':
			src = parkingIcons[getStorageClass(squareFootage, parkingIcons)];
			break;
		case 'outdoor':
			src = outdoorImage;
			if (amenities?.covered) {
				src = parkingImage;
			}
			break;
		case 'workspace':
			src = workspaceImage;
			break;
		case 'wine_storage':
			src = wineImage;
			break;
		default:
			src = icons[getStorageClass(squareFootage, icons)];
			break;
	}

	return (
		<Image
			className={className ? `unit-icon ${className}` : 'unit-icon'}
			alt="unit icon"
			lazyLoad={false}
			src={src}
		/>
	);
}

UnitIconV2.propTypes = {
	amenities: PropTypes.shape({
		covered: PropTypes.bool,
	}),
	squareFootage: PropTypes.number,
	type: PropTypes.string,
	className: PropTypes.string,
};

export default UnitIconV2;
